import React from 'react';
import ContactForm from './ContactForm';

const CTASection = () => {
  return (
    <section id="cta" className="py-24 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="relative overflow-hidden rounded-3xl">
          <div className="absolute inset-0 bg-gradient-to-br from-indigo-600/20 via-purple-600/20 to-indigo-600/20" />
          <div className="absolute inset-0 bg-slate-900/80" />
          <div className="absolute inset-0 opacity-30"
               style={{
                 backgroundImage: `radial-gradient(circle at 20% 50%, rgba(99,102,241,0.3) 0%, transparent 50%),
                                   radial-gradient(circle at 80% 50%, rgba(139,92,246,0.3) 0%, transparent 50%)`
               }} />
          <div className="relative z-10 p-12">
            <ContactForm showHeading={true} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
